import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.type_report_local',
  local_managed: 'reporting.type_report_local_managed',
};
